<template>
<div class="chapter">
<div class="inner_page">
<p class="C144" style="margin-top:5%;"><strong><a id="page_xvii"></a>T<span class="small">HE</span> V<span class="small">ICAR</span>’<span class="small">S</span> D<span class="small">AUGHTER</span></strong></p>
<p class="C158"><strong>1872</strong></p>
<p class="C103">The Cullen Collection</p>
<p class="C160">Volume 14</p>
<p class="C98"><img alt="" height="auto" src="Images/image00204.jpeg" width="65%"/></p>
<p class="C98"><img alt="" height="auto" src="Images/image00205.jpeg" width="81%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0009.vue?d972a18a